import type { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import type { LogicTypeStepWorkspaceWriteJsonMergePatchModel as Step } from '@r/api/generated/client.schemas.ts';

export const useStepsColumns = (): ColumnDef<Step>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'name',
      header: t('form.step.name.label')
    },
    {
      accessorKey: 'description',
      header: t('form.step.description.label'),
      cell: ({ row }) => {
        return row.original.description;
      }
    },
    {
      accessorKey: 'stepPoint',
      header: t('form.step.point.label')
    }
  ];
};
